export default {
  all_lists: [],
  thislist: {},
  listentries: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/lists/state.js